@if (!!pendingTrades.length) {
  <div class="max-w-964 center-block pending-trade-ribbon">
    <span class="bpi__icon-info"></span>
    <span>{{ "wallet_details_pending_trades_info" | translate: [pendingTrades.length] }}</span>
  </div>
}
